import React from 'react';
import { Trash2, FileText, Calendar, Clock } from 'lucide-react';

const ResumeHistoryModal = ({ isOpen, onClose, resumes, onLoad, onDelete }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col overflow-hidden">
                {/* Header */}
                <div className="p-6 border-b border-slate-100 flex justify-between items-center bg-slate-50">
                    <div>
                        <h2 className="text-xl font-bold text-slate-800">Saved Resumes</h2>
                        <p className="text-sm text-slate-500">Select a resume to load</p>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-slate-400 hover:text-slate-600 transition-colors text-2xl"
                    >
                        &times;
                    </button>
                </div>

                {/* List */}
                <div className="flex-1 overflow-y-auto p-6 space-y-3">
                    {resumes.length === 0 ? (
                        <div className="text-center py-12 text-slate-400">
                            <FileText size={48} className="mx-auto mb-4 opacity-50" />
                            <p>No saved resumes found.</p>
                        </div>
                    ) : (
                        resumes.map((resume) => (
                            <div
                                key={resume.id}
                                className="border border-slate-200 rounded-lg p-4 hover:border-blue-300 hover:bg-blue-50 transition-all group flex items-center justify-between"
                            >
                                <div className="flex-1 cursor-pointer" onClick={() => onLoad(resume)}>
                                    <h3 className="font-semibold text-slate-800 mb-1 flex items-center gap-2">
                                        {resume.title || 'Untitled Resume'}
                                    </h3>
                                    <div className="flex items-center gap-4 text-xs text-slate-500">
                                        <div className="flex items-center gap-1">
                                            <Calendar size={12} />
                                            {resume.createdAt.toLocaleDateString()}
                                        </div>
                                        <div className="flex items-center gap-1">
                                            <Clock size={12} />
                                            {resume.createdAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                        </div>
                                    </div>
                                </div>

                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onDelete(resume.id); // Immediate delete, assuming user knows what "Trash" means
                                    }}
                                    className="p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                                    title="Delete Resume"
                                >
                                    <Trash2 size={18} />
                                </button>
                            </div>
                        ))
                    )}
                </div>

                {/* Footer */}
                <div className="p-4 border-t border-slate-100 bg-slate-50 text-right">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-slate-600 hover:bg-slate-200 rounded-lg text-sm font-medium transition-colors"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ResumeHistoryModal;
